import React, { useContext, useState } from 'react';
import Input from '../../Input/Input';
import validator from 'validator';
import './PersonalInfo.css';
import AddressMap from '../../AddressMap/AddressMap';

// 1. Import Leaflet and its default CSS
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

import { CheckedIcon } from '../../../assets/icons/icons';
import { Link } from 'react-router-dom';
import { ConfigContext } from '../../../assets/contexts/configContext';
import { DELIVERY_TYPE_VALUES, NO_DELIVERY_TYPE, OWN_DELIVERY_TYPE } from '../../../assets/utils/constants';
import AddressInput from './AddressInput/AddressInput';
import { formatNewAddress } from '../../../assets/utils/utils';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { motion } from 'framer-motion';
import useWindowSize from '../../../assets/hooks/useWindowSize';

// 2. Fix the default marker icon paths so markers appear correctly
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});



function PersonalInfo({
  personal,
  setPersonal,
  personalValidity,
  setPersonalValidity,
  delivery,
  setDelivery,
  total,
  setActiveBtn,
  activeBtn,
}) {
  const { width } = useWindowSize()
  const config = useContext(ConfigContext);
  const { initialConstants } = config;
  const { CONSTANTS, DELIVERIES, SHOP_PAYMENTS} = initialConstants;
  const { SHOW_DELIVERY = true } = CONSTANTS;

  const [ymap, setYmap] = useState(null);

  const PAYMENT_TYPE_VALUES = SHOP_PAYMENTS &&
    SHOP_PAYMENTS.filter((item) => item.payment.type === 'stripe').length > 0 &&
    SHOP_PAYMENTS.filter((item) => item.payment.type === 'stripe')[0].limit &&
    Number(SHOP_PAYMENTS.filter((item) => item.payment.type === 'stripe')[0].limit) > Number(total.PRICE) ?
    [
      {
        name: 'Pay on Delivery',
        key: 'manager',
      },
      {
        name: 'Pay Now in Crypto',
        key: 'cryptocloud',
      },
      {
        name: 'Pay Now by Card',
        key: 'stripe',
      },
    ]
    :
    [
      {
        name: 'Pay on Delivery',
        key: 'manager',
      },
      {
        name: 'Pay Now in Crypto',
        key: 'cryptocloud',
      },
    ]

  function handleChange(e) {
    const input = e.target;
    const name = input.name;
    let value = input.value;

    switch (name) {
      case 'phone':
        let inputValue = value.replace(/\D/g, '');
        let formattedInputValue = '';
        if (!inputValue) {
          setPersonal((prevValue) => ({
            ...prevValue,
            [name]: '',
          }));
          setPersonalValidity((prevValue) => ({
            ...prevValue,
            [name]: {
              errorMessage: '',
              validState: false,
            },
          }));
        } else {
          formattedInputValue = '+' + inputValue.substring(0, 16);
          if (inputValue.length >= 11) {
            setPersonalValidity((prevValue) => ({
              ...prevValue,
              [name]: {
                errorMessage: '',
                validState: true,
              },
            }));
          } else {
            setPersonalValidity((prevValue) => ({
              ...prevValue,
              [name]: {
                errorMessage: '',
                validState: false,
              },
            }));
          }
        }
        setPersonal((prevValue) => ({
          ...prevValue,
          [name]: formattedInputValue,
        }));
        break;

      case 'email':
        if (!value) {
          setPersonalValidity((prevValue) => ({
            ...prevValue,
            [name]: {
              errorMessage: '',
              validState: false,
            },
          }));
        }
        if (value.length >= 2) {
          if (validator.isEmail(value)) {
            setPersonalValidity((prevValue) => ({
              ...prevValue,
              [name]: {
                errorMessage: '',
                validState: true,
              },
            }));
          } else {
            setPersonalValidity((prevValue) => ({
              ...prevValue,
              [name]: {
                errorMessage: !e.target.validity.valid
                  ? e.target.validationMessage
                  : 'Invalid email',
                validState: false,
              },
            }));
          }
        }
        setPersonal((prevValue) => ({
          ...prevValue,
          [name]: value,
        }));
        break;

      default:
        setPersonal((prevValue) => ({
          ...prevValue,
          [name]: value,
        }));
        break;
    }
  }

  function handlePhoneDelete(e) {
    if (e.keyCode === 8 && e.target.value.replace(/\D/g, '').length === 1) {
      setPersonal((prevValue) => ({
        ...prevValue,
        phone: '',
      }));
    }
    if (e.keyCode === 8 && e.target.value.replace(/\D/g, '').length < 11) {
      setPersonalValidity((prevValue) => ({
        ...prevValue,
        phone: {
          errorMessage: '',
          validState: false,
        },
      }));
    }
  }

  function handleSelectDeliveryType({ item }) {
    setDelivery((prevValue) => ({
      ...prevValue,
      type: item,
      hint_selected: '',
      address: '',
      entrance: '',
      entry_code: '',
      floor: '',
      apartment: '',
      comment: '',
    }));
    console.log(item);
  }

  function toggleCheckbox() {
    setPersonal((prevValue) => ({
      ...prevValue,
      checkbox: !prevValue.checkbox,
    }));
  }

  function handleDeliveryChange(e) {
    const input = e.target;
    const name = input.name;
    let value = input.value;
    setDelivery((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  }

  function handleSelectPaymentType({ item }) {
    setPersonal((prevValue) => ({
      ...prevValue,
      payment_type: item,
    }));
  }

  return (
    <form
      className="personal-info"
      onSubmit={(evt) => {
        evt.preventDefault();
      }}
    >
      <div className="personal-info__inputs-container">
        {/* Payment type buttons */}
        {PAYMENT_TYPE_VALUES && PAYMENT_TYPE_VALUES.length > 0 && (
          <div
            className="personal-info__btn-box"
            style={{
              gridTemplateColumns: `repeat(${PAYMENT_TYPE_VALUES.length > 2 ? width >= 500 ? PAYMENT_TYPE_VALUES.length : '1' : PAYMENT_TYPE_VALUES.length}, minmax(0, 1fr))`,
            }}
          >
            {PAYMENT_TYPE_VALUES.map((item, i) => (
              <button
                className={`personal-info__btn ${personal?.payment_type?.key === item.key
                  ? 'personal-info__btn_active'
                  : ''
                  }`}
                key={`personal-info__select-input_payment-type_${i}`}
                type="button"
                onClick={() => {
                  handleSelectPaymentType({ item });
                }}
              >
                {item.name}
              </button>
            ))}
          </div>
        )}

        {/* Delivery type buttons */}
        {DELIVERIES && DELIVERIES.length > 1 && (
          <div
            className="personal-info__btn-box"
            style={{
              gridTemplateColumns: `repeat(${DELIVERIES.length}, minmax(0, 1fr))`,
            }}
          >
            {DELIVERIES.map((item, i) => (
              <button
                className={`personal-info__btn ${delivery?.type?.delivery_type === item.delivery_type
                  ? 'personal-info__btn_active'
                  : ''
                  }`}
                key={`personal-info__select-input_delivery-type_${i}`}
                type="button"
                onClick={() => {
                  handleSelectDeliveryType({ item });
                }}
              >
                {DELIVERY_TYPE_VALUES[item.delivery_type]}
              </button>
            ))}
          </div>
        )}

        {/* Personal data inputs */}
        <div className="personal-info__two-inputs">
          <div className="personal-info__inputs-column">
            <div className="personal-info__input">
              <Input
                label="Name"
                value={personal.first_name}
                handleChange={handleChange}
                name="first_name"
              />
            </div>
            <div className="personal-info__input">
              <Input
                label="Surname"
                value={personal.last_name}
                handleChange={handleChange}
                name="last_name"
              />
            </div>
            <div className="personal-info__input">
              <Input
                label="Phone Number"
                value={personal.phone}
                handleChange={handleChange}
                name="phone"
                inputMode="tel"
                error={personalValidity.phone}
                onKeyDown={handlePhoneDelete}
              />
            </div>
            <div className="personal-info__input">
              <Input
                label="E-mail"
                value={personal.email}
                handleChange={handleChange}
                name="email"
                inputMode="email"
              />
            </div>
          </div>

          {/* Delivery-specific section */}
          {delivery?.type.delivery_type === OWN_DELIVERY_TYPE ? (
            <motion.div
              animate={{ opacity: 1 }}
              initial={{ opacity: 0 }}
              exit={{ opacity: 0 }}
              className="personal-info__input-area-and-checkbox"
            >
              <div className="personal-info__input personal-info__input_area">
                <Input
                  label="Address"
                  value={delivery.address}
                  handleChange={handleDeliveryChange}
                  name="address"
                />
              </div>
              <button
                className={`personal-info__checkbox ${personal.checkbox ? 'personal-info__checkbox_selected' : ''
                  }`}
                onClick={toggleCheckbox}
                type="button"
              >
                <div className="personal-info__checkbox-box">
                  <CheckedIcon
                    mainClassName="personal-info__checkbox-box-icon"
                    strokeClassName="personal-info__checkbox-box-icon-stroke"
                  />
                </div>
                <p className="personal-info__checkbox-text">
                  I agree to the processing of my personal data in accordance
                  with the{' '}
                  <Link to="/docs/privacy-policy" className="personal-info__checkbox-text-link">
                    Privacy Policy.
                  </Link>
                </p>
              </button>
            </motion.div>
          ) : delivery?.type.data &&
            delivery?.type.delivery_type === NO_DELIVERY_TYPE ? (
            <motion.div
              animate={{ opacity: 1 }}
              initial={{ opacity: 0 }}
              exit={{ opacity: 0 }}
              className="personal-info__map-box"
            >
              <div className="personal-info__map-wrap">
                {/*/!* 3. Ensure .personal-info__map-wrap in CSS has a fixed height: e.g., height: 400px *!/*/}
                {/*<MapContainer*/}
                {/*  center={[*/}
                {/*    delivery?.type.data.coords[1],*/}
                {/*    delivery?.type.data.coords[0],*/}
                {/*  ]}*/}
                {/*  zoom={13}*/}
                {/*  scrollWheelZoom={false}*/}
                {/*  style={{ height: '100%', width: '100%' }} // ensure map has a size*/}
                {/*>*/}
                {/*  <TileLayer*/}
                {/*    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'*/}
                {/*    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"*/}
                {/*  />*/}
                {/*  /!* The Marker below is using [lat, lng] in that order *!/*/}
                {/*  <Marker*/}
                {/*    position={[*/}
                {/*      delivery?.type.data.coords[1],*/}
                {/*      delivery?.type.data.coords[0],*/}
                {/*    ]}*/}
                {/*  />*/}
                {/*</MapContainer>*/}
                <AddressMap
                    subClassName={'order'}
                    location={
                      { center: delivery?.type.data.coords, zoom: 13 }
                    }
                    setYmap={setYmap}
                />
              </div>
              <p className="personal-info__no-delivery-title">
                {delivery?.type.data?.store_address}
              </p>
            </motion.div>
          ) : null}
        </div>
      </div>

      {/* Additional container for address details, if needed */}
      <div className="personal-info__inputs-container">
        {/* Example of conditionally showing more address fields if needed */}
        {delivery?.type?.delivery_type === OWN_DELIVERY_TYPE ? (
          <>
            {/* Additional address fields, if desired */}
          </>
        ) : (
          SHOW_DELIVERY &&
          delivery?.type?.data &&
          activeBtn === 2 && (
            <>
              {/* For example: <p>Pickup address: {formatNewAddress(delivery.type.data)}</p> */}
            </>
          )
        )}
      </div>
    </form>
  );
}

export default PersonalInfo;
